export default __webpack_public_path__ + "static/media/mywallet.6b2dc00e.png";